export function capitalize(str) {
  let splitted = str.split(" ");

  return str
    .split(/([^a-zA-Z0-9]+)/)
    .map((token) => {
      if (/^[a-zA-Z0-9]+$/.test(token)) {
        return token.charAt(0).toUpperCase() + token.slice(1).toLowerCase();
      }
      return token;
    })
    .join("");
}
